import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'smart-mailer-view',
  templateUrl: './mailer-view.component.html',
  styleUrls: ['./mailer-view.component.scss']
})
export class MailerViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
